import { render, staticRenderFns } from "./_dailyWinlose.vue?vue&type=template&id=641d830c&lang=pug&"
import script from "./_dailyWinlose.vue?vue&type=script&lang=js&"
export * from "./_dailyWinlose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports